import React, { useEffect, useState } from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

//Importing Components
import { OutlinedButton } from "../../components/Buttons";
import SimpleAccordion from "../../components/Accordions";
import Testimonials from "../../components/Testimonials";

// Importing Projects Data
import projectsData from "../../projectsData";

import HeroTransparentImage from "../../assets/branding-logos/hero-image.webp"
// import HeroTransparentImage from "../../assets/branding-logos/transparent hero image.png"
import VerticalTabs from "../../components/VerticalTabs";
import FullWidthTabs from "../../components/FullWidthTabs";
import Projects from "../../components/Projects";
import Cards from "../../components/Cards";

import mentoring from "../../assets/placeholders/Mentoring.svg";
import opportunities from "../../assets/placeholders/Opportunities.svg";
import resources from "../../assets/placeholders/Resources.svg";
import reviews from "../../assets/placeholders/Reviews.svg";
import Monitor from "../../assets/placeholders/webdev.svg";
import UXDesign from "../../assets/placeholders/uiuxdesign.svg";
import Branding from "../../assets/placeholders/branding.svg";

import experience from "../../expData"

import style from "./style";



const useStyles = makeStyles(style);
function HomePage() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [IsDesktop, setIsDesktop] = useState(window.innerWidth > 900);

  const updateMedia = () => {
    setIsDesktop(window.innerWidth > 900);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return (
    <Grid className={`page ${classes.homePage}`}>
      {/* Hero Section */}
      <Grid className={` ${classes.heroSection}`}>
        <div style={{ position: "relative" }}>
          <div className={` ${classes.circletextcontainer} hover-detect`}>
            <a href="mailto:devrajchatribin9978@gmail.com?subject=Hire Me | Portfolio" target="_blank" rel="noreferrer" alt="Contact Me">
              <svg style={{ animation: "rotate 30s infinite linear" }} className={`${classes.circletextsvg}`} width="100" height="100">
                <path style={{ fill: "transparent" }} id="curve" d="M50 99C77.062 99 99 77.062 99 50C99 22.938 77.062 1 50 1C22.938 1 1 22.938 1 50C1 77.062 22.938 99 50 99ZM50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z" />
                <text width="0">
                  <textPath alignment-baseline="top" xlinkHref="#curve">
                    Contact · Contact · Contact ·
                  </textPath>
                </text>
              </svg>
            </a>
          </div>
          <div data-aos="fade-in" className={` ${classes.HeroImageContainer}`}>
            <img className={`${classes.HeroImage}`} width="100%" height="100%" src={HeroTransparentImage} alt="My Profile" />
          </div>
        </div>
        <div>
          <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
            Hi, my name is
          </Typography>
          <Typography variant="h2" data-aos="fade-in" className={classes.title}>
            Devraj Chatribin.
          </Typography>
          <Typography variant="h2" data-aos="fade-in" gutterBottom className={classes.stitle}>
            Bringing design to life.
          </Typography>
          <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
            I'm a web developer and UI/UX designer with a passion for front end development and design. I aspire toward a career that will allow me to showcase my creativity through crafting beautiful websites and engaging experiences.
          </Typography>
          <div className={classes.heroBtns}>
            <Link to={`/about`} className="hover-detect">
              <OutlinedButton data-aos="fade-in" size="large">About Me</OutlinedButton>
            </Link>
            <Link to={`/projects`} className="hover-detect">
              <OutlinedButton data-aos="fade-in" size="large">My Projects</OutlinedButton>
            </Link>
          </div>
        </div>
      </Grid>

      {/* Marquee Animation */}
      <h1 className="leftlmq">
        Websites. Designing. Graphics. Animation. Websites. Designing. Graphics. Animation. Figma. AdobeXD. Enthusiast.
      </h1>
      <h1 className="rightlmq">
        Community. Development. Mentor. Prototype. Websites. Community. Development. Mentor. Prototype. Websites.
      </h1>

      {/* Projects Section */}
      <Grid
        container
        className={`${classes.section} ${classes.ProjectsSection}`}
      >
        <Typography
          variant="h2"
          gutterBottom
          data-aos="fade-in"
          className={classes.secondaryTitle}
        >
          Explore my work
        </Typography>
        <Grid container>
          {
            projectsData.slice(0, 3).map((project) => {
              return <Projects
                image={project.image}
                title={project.title}
                text={
                  project.shortDescription
                }
                stack={project.technology}
                id={project.id}
                githubLink={project.sourceCode}
                liveLink={project.projectLink}
              />
            })
          }

          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Link to={`/projects`} className="hover-detect">
              <OutlinedButton data-aos="fade-in" aria-label="View all projects" size="large">View All Projects</OutlinedButton>
            </Link>
          </div>
        </Grid>
      </Grid>

      {/* Experience Section */}
      <Grid container className={`${classes.section} ${classes.ExpSection}`}>
        <Typography
          variant="h2"
          gutterBottom
          data-aos="fade-in"
          className={classes.secondaryTitle}
        >
          Professional Experience
        </Typography>
        {IsDesktop ? <VerticalTabs data={experience} /> : <FullWidthTabs data={experience} />}
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <a href="https://www.linkedin.com/in/devraj-chatribin/" target="_blank" rel="noreferrer" className="hover-detect">
            <OutlinedButton data-aos="fade-in" size="large">View All Experience</OutlinedButton>
          </a>
        </div>
      </Grid>

      {/* Community Section */}
      <Grid container className={`${classes.section}`}>
        <Typography
          variant="h2"
          gutterBottom
          data-aos="fade-in"
          className={classes.secondaryTitle}
        >
          Building a Tech Community
        </Typography>
        <Grid container className={`${classes.communitySection}`}>

          <Grid className={`${classes.leftSection}`}>
            <Grid data-aos="fade-in" className={`${classes.communityCards}`}>
              <img
                src={mentoring}
                data-aos="fade-in"
                className={classes.communityCardImg}
                alt="Mentoring Students"
              />
              <Typography data-aos="fade-in" variant="h6" className={` ${classes.card__title} ${classes.textAlignLeft}`}>
                Mentoring Students
              </Typography>
              <Typography data-aos="fade-in" variant="subtitle1" className={`${classes.description} ${classes.secondaryDesc} ${classes.textAlignLeft}`}>
                Get connected with a mentor that will help you pave your career path
              </Typography>
            </Grid>
            <Grid data-aos="fade-in" className={`${classes.communityCards}`}>
              <img
                src={opportunities}
                data-aos="fade-in"

                className={classes.communityCardImg}
                alt="Opportunities"
              />
              <Typography data-aos="fade-in" variant="h6" className={` ${classes.card__title} ${classes.textAlignLeft}`}>
                Opportunities
              </Typography>
              <Typography data-aos="fade-in" variant="subtitle1" className={`${classes.description} ${classes.secondaryDesc} ${classes.textAlignLeft}`}>
                Get Internships and Job opportunities and gain experience while you learn.
              </Typography>
            </Grid>
            <Grid data-aos="fade-in" className={`${classes.communityCards}`}>
              <img
                src={resources}
                data-aos="fade-in"

                className={classes.communityCardImg}
                alt="Free Resources"
              />
              <Typography data-aos="fade-in" variant="h6" className={` ${classes.card__title} ${classes.textAlignLeft}`}>
                Free Resources
              </Typography>
              <Typography data-aos="fade-in" variant="subtitle1" className={`${classes.description} ${classes.secondaryDesc} ${classes.textAlignLeft}`}>
                Get Free resources related to Designing and Development from the community.
              </Typography>
            </Grid>
            <Grid data-aos="fade-in" className={`${classes.communityCards}`}>
              <img
                src={reviews}
                data-aos="fade-in"

                className={classes.communityCardImg}
                alt="Help and Reviews"
              />
              <Typography data-aos="fade-in" variant="h6" className={` ${classes.card__title} ${classes.textAlignLeft}`}>
                Help & Reviews
              </Typography>
              <Typography data-aos="fade-in" variant="subtitle1" className={`${classes.description} ${classes.secondaryDesc} ${classes.textAlignLeft}`}>
                Get your portfolio and projects reviewed by Industry experts and mentors.
              </Typography>
            </Grid>
          </Grid>
          <Grid className={`${classes.rightSection}`}>
            <Typography
              variant="h6"
              gutterBottom
              data-aos="fade-in"
              className={classes.description}
            >
              I founded Design & Code which is a global community with a mission to connect designers and developers to create a happy community eager to learn, innovate and grow together. We welcome all designers and developers: beginners, intermediates, and experts willing to learn together. We encourage sharing resources and learning experiences, organizing events, and providing feedback for our members to grow as they learn.
            </Typography>
            <br />
            <Typography
              variant="h4"
              gutterBottom
              data-aos="fade-in"
              className={classes.stitle}
            >
              Ready to Start your journey?
            </Typography>
            <Grid style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem" }}>
              <Grid>
                <Typography variant="h6" data-aos="fade-in" className={`${classes.counter} counter`}>4k+</Typography>
                <Typography variant="h6" data-aos="fade-in" className={classes.description}>Community Members</Typography>
              </Grid>
              <Grid>
                <Typography variant="h6" data-aos="fade-in" className={`${classes.counter} counter`}>15+</Typography>
                <Typography variant="h6" data-aos="fade-in" className={classes.description}>Events and Workshops</Typography>
              </Grid>
              <Grid>
                <Typography variant="h6" data-aos="fade-in" className={`${classes.counter} counter`}>18</Typography>
                <Typography variant="h6" data-aos="fade-in" className={classes.description}>Months</Typography>
              </Grid>
            </Grid>
            <br />
            <span className="hover-detect">
              <OutlinedButton data-aos="fade-in" href="https://discord.gg/gM3bG4rAU5" target="_blank" size="large" >Join Community</OutlinedButton>
            </span>
          </Grid>
        </Grid>

      </Grid>

      {/* Services Section */}
      <Grid
        container
        className={`${classes.section} ${classes.ServicesSection}`}
      >
        <Typography
          variant="h2"
          gutterBottom
          data-aos="fade-in"
          className={classes.secondaryTitle}
        >
          My Expertise
        </Typography>

        <Grid container>
          <Cards
            image={Monitor}
            title={"Web Development"}
            text={
              "Building responsive websites. Providing the users an enriching experience that responds to any device and screen size."
            }
          />
          <Cards
            image={UXDesign}
            title={"UI/UX Designing"}
            text={
              "Designing user-centric, modern interfaces that shapes how the audience interacts with the product."
            }
          />
          <Cards
            image={Branding}
            title={"Brand Design"}
            text={
              "Building brand identities including working on logo, typography, iconography, colour palette, visual language, and brand personality."
            }
          />
        </Grid>
      </Grid>

      {/* Testimonials Section */}
      <Typography data-aos="fade-in" variant="h2" gutterBottom className={classes.subTitle}>
        What others say
      </Typography>
      <Typography data-aos="fade-in" data-aos-delay="200" variant="h6" gutterBottom className={classes.sTitle}>
        I've worked with some amazing people over the years, here is what they have to say
      </Typography>
      <Grid container className={`testimonial-section`}>
        <Testimonials data={[
          {
            name: "Vritika Naik",
            role: "Regional Head @GirlScript",
            text: "I am amazed at Devraj's ability to create intriguing designs. At GirlScript, Devraj not only worked with graphic designing but also designed the UI and contributed to the front end of the website. His work ethics are immaculate. His deliveries were always very well executed before time. His energy to make things happen is contagious and it helps achieve great goals. It is always a pleasure working with Devraj and I am confident that he will be an asset to any team that he is a part of.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/vritika-naik.webp"
          },
          {
            name: "Praveen Kumar Purushothaman",
            role: "Full Stack Developer | ReactJS Specialist | YouTuber",
            text: "Devraj is not only a great designer but also a community guy. He created the DC community and it's something really commendable. One of the best folks for development and design combined. We have worked on several projects together and that's how I got to know more about him and definitely he's one of the best.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/praveen-science.webp"
          },
          {
            name: "Trusha Neogi",
            role: "UI/UX Design Intern @Hexcoderz",
            text: "Devraj is not only an exceptional UI/UX designer but also a proficient developer! His projects are impressive and indicate how good his UX skills are. He knows how to function in a team setting and has leadership qualities. What makes him stand out is that he is artistic, hardworking, and humble. I would highly recommend him to anyone who needs web development and designing services.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/trusha-neogi.webp"
          },
          {
            name: "Nijin Nazar",
            role: "SDE Intern @CuriousJr",
            text: "I came to know about Devraj as a Web Designer and Content Creator. But by time, I got to know him more personally and found a gem. He is an awesome UI/UX Designer and Web Developer with a lot of modern creative ideas, which makes him outstanding in this field. I always respect his mentorship & leadership skills. His ability to lead a team or organize a program is awesome. He is a real inspiration for me as a Developer and Mentor. If you are looking for someone, who is awesome at UI/UX or Web Development or Mentoring or for Volunteering a Program then he is the right choice that you won't regret later.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/nijin-nazar.webp"
          },
          {
            name: "Ankita Sahu",
            role: "Google Crowdsource Influencer",
            text: "I've come across a lot of people in tech field but what makes Devraj stand out the most is,his passion and dedication!He has been a great mentor and co-ordinator ,and has shown exemplary leadership skills for his community.His web dev skills and amazing UI/UX aren't just portrayed in his projects,he uses his skills to mentor masses and works for social well being.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/ankita-sahu.webp"
          },
          {
            name: "Vipula Sail",
            role: "Google DSC Lead | Engage Mentee @Microsoft",
            text: "Devraj's UX design skills are on par with professionals. His projects speak volumes of his talent and his mastery in the UX domain. Not only is he a great mentor, but also a wonderful team player. I highly recommend him for his web development and design proficiency. ",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/vipula-sail.webp"
          },
          {
            name: "Greeshma Medam",
            role: "Core-Team member @Design & Code",
            text: "Devraj is someone I have always looked up to as a role model. He is a considerate, determined and detail-oriented person who thoroughly enjoys his work. He is not only a good developer but also a very thoughtful UI/UX designer. His attention to detail was very evident while I worked under his guidance in building the Design and Code community. He is a great team player and a leader who always encourages the people around him to push their limits and experiment. I am confident he would be a huge asset for anyone having him on their team.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/greeshma-medam.webp"
          },
          {
            name: "Hardik Kumar",
            role: "Founder @INAXIA, @Hacking Heist | DevRel intern @Keploy",
            text: "Devraj worked as a Website Designer at Hacking Heist 1.0 in our team. I was impressed by his consistent efforts in making the UI ready as soon as possible so that developers could start building it. He completed the whole web design within a week, so there's no doubt that he's hard-working too.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/hardik-kumar.webp"
          },
          {
            name: "Nimish Jain",
            role: "Core-Team member @Design & Code",
            text: "I have worked with Devraj on a few projects and assisted him in building Design and Code Community as a Core Team member. He is hard-working and always dedicated to his work. He is not only a great UI/UX designer but also a great web developer. Design and Code wouldn't happen without his leadership and team spirit. I always look forward to working with him.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/nimish-jain.webp"
          },
          {
            name: "Shrutika Gawas",
            role: "Social Media Manager @Design & Code",
            text: "Devraj is amazing at creating intriguing designs.He is not only an exceptional UI/UX designer but also a proficient developer, an amazing mentor and a co-ordinator. Devraj has shown exemplary leadership skills for his community and has helped a lot of people gain some knowledge through his social events. I would really recommend him to anyone who needs a hardworking and passionate person for web development and designing services",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/shrutika-gawas.webp"
          },
          {
            name: "Shridhar Kamat",
            role: "Front-end Developer",
            text: "I have collaborated with Devraj on many projects and participated in hackathons with him. He is a fantastic developer and a great UI/UX designer. His designs focus mainly on solving real-world problems yet are clean and minimal. He is a very creative and passionate person and one of the best community managers I have known.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/shridhar-kamat.webp"
          },
          {
            name: "Purnima Sharma",
            role: "Software Engineer Intern @Accolite",
            text: "Devraj is a very professional person. I am sure he will achieve great things in his career. He is very creative, hands-on, and organized. He is knowledgeable in expertise and innate leadership quality. Devraj leads by example, and many people in the workplace find his enthusiasm and dedication, both inspiring and motivating. I am lucky to work for such personnel.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/purnima-sharma.webp"
          },
          {
            name: "Sai Koushik",
            role: "Freelance Web Designer",
            text: "Devraj is very creative and adaptive person. I have worked with Devraj on several design projects. His skills and abilities shows his passion towards design and development. He is always curious to learn with an open mind. He is also a great mentor and is always ready to help. Devraj will definitely be a valuable asset to any company.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/sai-koushik.webp"
          },
          {
            name: "Shriram Parab",
            role: "Media And Productions Head, Team Phoenix Goa",
            text: "Devraj is a great designer and an awesome team player. I and Devraj have worked on various UI/UX design projects. Apart from UI/UX design he is also a great web developer. He also runs Design and Code community which helps designers and developers to collaborate and learn from each other. He will be a valuable asset to any company.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/shriram-parab.webp"
          },
          {
            name: "Divyanshi Oberoi",
            role: "Microsoft Imagine Cup 2022 India Semifinalist",
            text: "Devraj is one of the most dedicated professionals I met. He is very creative person.He mentored me with UI/UX.He always helped me with web development and designs.Devraj will be a valuable asset to any company.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/divyanshi-oberoi.webp"
          },
          {
            name: "Krupashri Koli",
            role: "Campus Hero @Girlscript Goa",
            text: "Devraj is an enthusiast. He is very creative and dedicated towards his work. He has grown very well in the field of designing and web dev as per my observation. Even while working in a group, he is well aware of how he needs to keep all the members together and work efficiently. I certainly recommend Devraj for his skills and believe he'll do a wonderful job for any assigned task.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/krupashri-koli.webp"
          },
          {
            name: "Swaroop Rajwal",
            role: "Front-end Developer @Design & Code",
            text: "Devraj is very good at UI/UX designing and Web Development. Having worked with him from a long time, I like that he is well aware about clean code and his design are also so attractive and simply minimalistic. He also helps people a lot in the community and knows well how to treat others with respect.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/swaroop-rajwal.webp"
          },
          {
            name: "Satish Baiginkar",
            role: "Content-writer @Design & Code",
            text: "Since I have been working with Devraj for quite a while, I can assure you that the UI/UX designing skills are way more professional and intriguing as compared to the other developers I've seen. I m lucky to have this person as the leader as his leadership skills are really well developed and people hiring this person would be really lucky to have him a part of the team.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/satish-baiginkar.webp"
          },
          {
            name: "Samiksha Pawar",
            role: "Software Engineer @Conexao Technology Solutions",
            text: "Devraj is a very artistic person. We have worked as graphic designers for a regional event. He is amazing at designing as well as web designing. I surely recommend him to everyone who needs these services.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/samiksha-pawar.webp"
          },
          {
            name: "Pragati Agrawal",
            role: "Front-end Web Developer",
            text: "Devraj is a very creative person and very professional. I have learned many things from him. He is postive and helpful. He never hesitated to provide support when needed. I highly recommend him to anyone who needs design and Website work",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/pragati-agrawal.webp"
          },
          {
            name: "Gurusai G.",
            role: "Associate Technical Consultant @Vuram",
            text: "Not everyone that I can see have the heart to talk to a stranger and spending their most valuable time. Devraj is one such humble person who guided me on how to start web development. He suggested me how to proceed to master web development and also he shared some of his important activities that he has done. That has helped me a lot on how to proceed further. He is not only good at UI/UX Design but also very good at web development.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/gurusai.webp"
          },
          {
            name: "Sweatlana Martins",
            role: "Student at Padre Conceicao College of Engineering",
            text: "Devraj is hardworking, talented and a creative person. He has amazing ideas and also good programming skills . He is always enthusiastic in learning new things and sharing his valuable experiences to help people grow.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/sweatlana-martins.webp"
          },
          {
            name: "Sattyam Mane",
            role: "Flutter Developer",
            text: "One of the most amazing personalities I met and I am impressed with his way of finding solutions to digital problems using his abilities and skills of UI/UX Design and Web Development. Having worked with Devraj since long time, I am sure that he will be a great asset to you/your company.",
            link: "https://www.linkedin.com/in/devraj-chatribin/details/recommendations/",
            src: "/assets/testimonials/sattyam-mane.webp"
          }
        ]} />
      </Grid>

      {/* FAQ Section */}
      <Grid container className={`${classes.section}`}>
        <Typography data-aos="fade-in" variant="h2" gutterBottom className={classes.secondaryTitle}>
          Frequently Asked Questions
        </Typography>
        <Grid container className={classes.faq_container}>
          <Grid container xs={12} sm={6} className={classes.faq_grid}>
            <Grid className={classes.faq_grid1}>
              <SimpleAccordion
                index={0}
                expanded={expanded}
                setExpanded={setExpanded}
                disableGutters={true}
                title={"What all services do you offer?"}
                description={
                  "I take all kinds of development and designing related projects. Which includes UI/UX designing, frontend development, graphic designing."
                }
              />
              <SimpleAccordion
                index={1}
                expanded={expanded}
                setExpanded={setExpanded}
                title={"How much does it cost get started with a high performing website?"}
                description={
                  "It will depend upon the scope and requirements of the project. In a meeting, we will seek to identify specifics and objectives like number of pages, specific features, timeline, etc. All these will contribute to the cost and will vary from project to project."
                }
              />
              <SimpleAccordion
                index={2}
                expanded={expanded}
                setExpanded={setExpanded}
                title={"How long will the work take from start to finish?"}
                description={
                  "It will depend upon the scope and requirements of the project. A single landing page will take upto 1-3 weeks. A Full website with 8-10 pages may take 6-8 weeks."
                }
              />
            </Grid>
          </Grid>
          <Grid container xs={12} sm={6} className={classes.faq_grid}>
            <Grid className={classes.faq_grid1}>
              <SimpleAccordion
                index={3}
                expanded={expanded}
                setExpanded={setExpanded}
                title={"Where can you see more of me?"}
                description={
                  "You’ll find me very active on Linkedin and you can also check out my other socials to see more of my work."
                }
              />
              <SimpleAccordion
                index={4}
                expanded={expanded}
                setExpanded={setExpanded}
                title={"Are you available to join as full time?"}
                description={
                  "Yes, I am available to join as full time in a company that will allow me to showcase my creativity through crafting beautiful websites, designs and engaging experiences."
                }
              />
              <SimpleAccordion
                index={5}
                expanded={expanded}
                setExpanded={setExpanded}
                title={"How can you get in touch with me?"}
                description={
                  "You can use the above contact form to begin the conversation or you can directly mail me at: devrajchatribin9978@gmail,com."
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
}

export default HomePage;
